'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ComboBox = require('../../managewidgets/components/combobox/ComboBox');

var _ComboBox2 = _interopRequireDefault(_ComboBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ComboboxTypeAhead = function (_React$Component) {
  (0, _inherits3.default)(ComboboxTypeAhead, _React$Component);

  function ComboboxTypeAhead(props) {
    (0, _classCallCheck3.default)(this, ComboboxTypeAhead);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ComboboxTypeAhead.__proto__ || (0, _getPrototypeOf2.default)(ComboboxTypeAhead)).call(this, props));

    _this.onTextChange = function (value) {
      _this.text = value;
      _this.getComboData();
    };

    _this.onExpand = function () {
      _this.getComboData();
    };

    _this.getComboData = function () {
      // allow dynamic endpoints to include current text in search
      var endpoint = _this.props.getEndpoint(_this.text);
      _this.props.getComboData(endpoint);
    };

    _this.text = '';
    _this.timeStamp = undefined;
    return _this;
  }

  (0, _createClass3.default)(ComboboxTypeAhead, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_ComboBox2.default, (0, _assign2.default)({}, this.props, {
        filterOnPartialMatch: true,
        items: this.props.items,
        onTextChange: this.onTextChange,
        onExpand: this.onExpand
      }));
    }
  }]);
  return ComboboxTypeAhead;
}(_react2.default.Component);

exports.default = ComboboxTypeAhead;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/comboboxtypeahead/ComboBoxTypeAhead.js
// module id = 323
// module chunks = 10